import { Component, OnInit } from '@angular/core';
import { PROGRESS_NOTES_FIELD } from 'src/app/global';
import { HtmlDialogComponent } from 'src/app/shared/html-dialog/html-dialog.component';
import { NoteDialogComponent } from 'src/app/patients/dashboard-page/provider-charts-tab/note-dialog/note-dialog.component';
import { PatientDashboardTabComponent } from 'src/app/patients/dashboard-page/dashboard-tab/dashboard-tab.component';
import { Note } from 'src/app/calvin-emr-shared/models/note.model';
import { DialogService } from 'primeng/dynamicdialog';
import { PatientDashboardStore } from 'src/app/patients/state/dashboard-page.store';
import { Patient } from 'src/app/calvin-emr-shared/models/patient.model';
import { Store } from '@ngrx/store';
import { toTitleCase } from 'src/app/shared/utils/string.util';
import { NgIf } from '@angular/common';
import { ButtonDirective } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { PrimeTemplate } from 'primeng/api';
import { TooltipModule } from 'primeng/tooltip';

@Component({
    selector: 'app-progress-notes-tab',
    templateUrl: './progress-notes-tab.component.html',
    styleUrls: ['./progress-notes-tab.component.scss'],
    providers: [DialogService],
    standalone: true,
    imports: [
        NgIf,
        ButtonDirective,
        TableModule,
        PrimeTemplate,
        TooltipModule,
    ],
})
export class ProgressNotesTabComponent extends PatientDashboardTabComponent implements OnInit {
  progressNotes: Note[] = [];

  constructor(
    patientStore: PatientDashboardStore,
    store: Store,
    public dialogService: DialogService
  ) {
    super(patientStore, store);
    this.patient$.subscribe((patient: Patient) => {
      this.progressNotes = patient.progressNotes;
    });
  }

  ngOnInit(): void {
    this.stopLoading();
  }

  viewNote(note: Note) {
    const dialogRef = this.dialogService.open(HtmlDialogComponent, {
      header: note.title,
      data: note,
      width: '50%',
    });
  }

  deleteNote(note: Note) {
    this.progressNotes = this.progressNotes.filter((n) => {
      return n.id !== note.id;
    });
    this.updatePatientField(PROGRESS_NOTES_FIELD, this.progressNotes);
  }

  openNoteDialog(type: 'create' | 'edit', note?: Note) {
    const header = `${toTitleCase(type)} Note`;
    let data = note ? { type: type, note: note } : { type: type };

    const dialogRef = this.dialogService.open(NoteDialogComponent, {
      header: header,
      width: '90%',
      data: data,
    });

    dialogRef.onClose.subscribe((note: Note) => {
      if (note) {
        if (type === 'create') {
          this.progressNotes.push(note);
        } else if (type === 'edit') {
          const indexToRemove = this.progressNotes.findIndex((n) => n.id == note.id);
          this.progressNotes.splice(indexToRemove, 1, note);
        }

        this.updatePatientField(PROGRESS_NOTES_FIELD, this.progressNotes);
      }
    });
  }
}
